import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { fromStore } from '../../../selectors';
import cn from 'classnames';
import Loader from '../../../components/utils/Loader';
import { isEmpty } from 'lodash';
import { ItemRow } from './ItemRow';
import { TableHeader } from './TableHeader';
import { useDispatch } from 'react-redux';
import { fetchIps } from '../../../action';
import ReactTooltip from 'react-tooltip';
import { styles } from '../styles';
import { PaginationList } from './PaginationList';

export function BlockedList() {
    const dispatch = useDispatch();
    const loaderList = useSelector(fromStore.loaderIpsSelector);
    const ips = useSelector(fromStore.ipsListSelector);

    useEffect(() => ReactTooltip.rebuild(), [ips, loaderList]);

    useEffect(() => {
        dispatch(fetchIps());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    return (
        <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid" style={{ padding: 0 }}>
            <div className="kt-portlet kt-portlet--mobile">
                <div className="kt-portlet__body kt-portlet__body--fit">
                    <div
                        style={{ position: 'relative', marginBottom: 0 }}
                        className={
                            cn('kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded', {
                                'kt-datatable--error': isEmpty(ips)
                            })
                        }>
                        {loaderList && <div style={styles.tableLoading}><Loader text='Загружаю данные'/></div>}
                        <table className="kt-datatable__table">
                            {window.innerWidth >= 550 && <TableHeader />}
                                <tbody className="kt-datatable__body">
                                    {
                                        loaderList
                                            ? null
                                            : isEmpty(ips)
                                                ? <tr><td colSpan={8}><span className="kt-datatable--error">Заблокированных IP пока нет</span></td></tr>
                                                : ips.map((item) => <ItemRow key={item.id} item={item} />)
                                    }
                                </tbody>
                        </table>
                        {ips.length > 0 && <PaginationList />}
                    </div>
                </div>
            </div>
           
            <ReactTooltip
                effect="solid"
                type="dark"
                place="top"
            />
        </div>
    );
}